import { useMemo } from 'react';
import { type AccountId } from '@/routes/_authenticated/_dashboard/accounts/$accountId/route.hooks';
import { type Branded } from '@/utils/types';

const NEW_SUPPORT_TICKET_URL = 'https://qdrant.atlassian.net/servicedesk/customer/portal/1/group/103/create/100';

export type ClusterEnvironmentProduction = Branded<10350, 'ClusterEnvironmentProduction'>;
export type ClusterEnvironmentDevelopment = Branded<10351, 'ClusterEnvironmentDevelopment'>;
export type ClusterEnvironmentOther = Branded<10352, 'ClusterEnvironmentOther'>;

/* eslint-disable @cspell/spellchecker */
const ALIAS_MAP = new Map([
  ['clusterEnvironment', 'customfield_10169'],
  ['clusterId', 'customfield_10170'],
  ['accountId', 'customfield_10171'],
  ['clusterVersion', 'customfield_10172'],
]);

interface ICreateSupportLinkFields {
  clusterEnvironment?: ClusterEnvironmentProduction | ClusterEnvironmentDevelopment | ClusterEnvironmentOther;
  clusterId?: string;
  accountId?: AccountId;
  clusterVersion?: string;
  /* eslint-enable @cspell/spellchecker */
  summary: string;
  description: string;
}

export const useServiceDeskLink = (props: ICreateSupportLinkFields) => useMemo(() => serviceDeskLink(props), [props]);

function serviceDeskLink({ summary, description, ...rest }: ICreateSupportLinkFields) {
  const searchParams = new URLSearchParams([
    ['summary', summary],
    ['description', description],
  ]);
  for (const [key, value] of Object.entries(rest)) {
    if (value) {
      searchParams.set(ALIAS_MAP.get(key) ?? key, String(value));
    }
  }
  const url = new URL(NEW_SUPPORT_TICKET_URL);
  url.search = decodeURIComponent(searchParams.toString());
  return url.toString();
}
